var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTwd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12.2673C24 18.8947 18.6274 24.2673 12 24.2673C5.37262 24.2673 0 18.8947 0 12.2673C4.12172 8.14562 7.61737 4.64996 12 0.267334C18.6274 0.267334 24 5.63996 24 12.2673Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.2673C12 5.63996 12 4.85865 12 0.267334C5.37262 0.267334 0 5.63996 0 12.2673H12Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.435 7.28855L8.96945 7.97799L9.74983 9.39732L8.15847 9.09282L7.95677 10.7005L6.84836 9.51811L5.73986 10.7005L5.53825 9.09282L3.94684 9.39722L4.72722 7.9779L3.26172 7.28855L4.72727 6.59926L3.94684 5.17988L5.5382 5.48433L5.73991 3.87671L6.84836 5.05908L7.95681 3.87671L8.15847 5.48433L9.74987 5.17988L8.96945 6.5993L10.435 7.28855Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84897 9.52405C8.08262 9.52405 9.0827 8.52397 9.0827 7.29031C9.0827 6.05666 8.08262 5.05658 6.84897 5.05658C5.61531 5.05658 4.61523 6.05666 4.61523 7.29031C4.61523 8.52397 5.61531 9.52405 6.84897 9.52405Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.84841 8.47986C6.19211 8.47986 5.6582 7.94591 5.6582 7.28961C5.6582 6.63332 6.19216 6.09937 6.84841 6.09937C7.50471 6.09937 8.03866 6.63332 8.03866 7.28961C8.03861 7.94591 7.50461 8.47986 6.84841 8.47986Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTwd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TWD.980d7a43bbd5ff95592edd41551f3a17.svg";